
const execute = (action) => {
  return new Promise((resolve, reject) => {
    grecaptcha.enterprise.ready(function () {
      grecaptcha.enterprise
        .execute("6LehykohAAAAAMpbs7zayi9a1ARwcBGeSOjrxkyK", { action })
        .then(function (token) {
          resolve(token);
        })
        .catch((err) => {
          reject(err);
        });
    });
  });
};

export { execute };



// WEBPACK FOOTER //
// ./js/base/tools.js